import React from "react";
import ReactApexChart  from "react-apexcharts";
import { formatAmount } from "../../../../../../../util/Helpers";

const LineChart = ({data, currency}) => {

    const chartData = data.map(el => ({y: el.close?.toFixed(2), x: new Date(el.date)}));
    
    const options = {
        series: [{
            name: "Close Price",
            data: chartData
        }],
        scale: {

    ticks: {
        maxTicksLimit: 5
    }},
        chart: {
            height: 350,
            type: 'line',
            toolbar: {
                tools: {
                  download: false,
                  reset: false,
                  selection: false,
                  zoom: false
                }
            }
        },
        dataLabels: { 	
            enabled: false
        },
        stroke: {
            curve: 'straight'
        },
        grid: {
            row: {
                colors: ['transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
            },
        },
        
        xaxis: {
            type: 'datetime',
            
        },
        yaxis: {
            labels: {
                formatter: value => formatAmount(currency, value)
            },
        },
        colors: ["#6993FF"],

        tooltip: {
            x: {
              format: 'dd MMM yyyy'
            }
          }
    };


    return <ReactApexChart options={options} series={options.series} height="500"/>

}

export default LineChart;